import { Flex, IconCheck, Text } from '@coverflex-tech/hypernova';
import classNames from 'classnames';
import { css } from './CheckList.css';

interface IProps {
  label?: string;
  points: string[];
  className?: string;
}

const Checklist = ({ label, points, className }: IProps) => (
  <div className={classNames(css.host, className)}>
    {label && <div>{label}</div>}
    <Flex flexDirection="column" gap="md">
      {points.map((point, idx) => (
        <Flex key={idx} alignItems="center" gap="sm">
          <IconCheck />
          <Text>{point}</Text>
        </Flex>
      ))}
    </Flex>
  </div>
);

export default Checklist;
